import React from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import FilterList from "@mui/icons-material/FilterList";
import { useTranslation } from "react-i18next";
import { User } from "../users/users-types";
import UserDetailsTable from "./UserDetailsTable";

export default function UsersSection(props: {
  users: User[];
  columns: string[];
  isLoading: boolean;
  isError: any;
}) {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [onlyActive, setOnlyActive] = React.useState(false);

  const handleMenuItem = (active: boolean) => {
    setOnlyActive(active);
    handleClose();
  };

  return (
    <Box>
      <Stack spacing={2} paddingTop={1}>
        <Stack direction="row" spacing={1} justifyContent="space-between">
          <Typography variant="h5">{t("Users")}</Typography>
          {props.users.length > 0 && (
            <Box>
              <IconButton
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <FilterList />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem onClick={() => handleMenuItem(false)}>
                  {t("View All")}
                </MenuItem>
                <MenuItem onClick={() => handleMenuItem(true)}>
                  {t("Only Active")}
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Stack>
        <UserDetailsTable
          columns={props.columns}
          users={
            onlyActive
              ? props.users.filter((user) => user.status !== "INACTIVE")
              : props.users
          }
          isLoading={props.isLoading}
          isError={props.isError}
        />
      </Stack>
    </Box>
  );
}
